import { avatar, avatarf } from "../assets";

export const feedbacks = [
    {
        id: 1,
        content: "Our caring and supportive team has experience working with patients face-to-face and dealing with mental health issues.Spend less time searching for help and more time connecting with someone you can trust.",
        avatarImg: avatar,
        username: "Christopher Nolan",
        role: "Our client"
    },
    {
        id: 2,
        content: "Spend less time searching for help and more time connecting with someone you can trust.",
        avatarImg: avatarf,
        username: "Jenny Wilson",
        role: "Patient"
    },
    {
        id: 3,
        content: "Our caring and supportive team has experience working with patients face-to-face and dealing with mental health issues.Spend less time searching for help and more time connecting with someone you can trust.",
        avatarImg: avatar,
        username: "Christopher Nolan",
        role: "Our client"
    },
    {
        id: 4,
        content: "Spend less time searching for help and more time connecting with someone you can trust.",
        avatarImg: avatarf,
        username: "Jenny Wilson",
        role: "Patient"
    },
]